import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './LegalPages.css';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="back-button" onClick={() => navigate('/')}>
          <FaArrowLeft /> Volver al Inicio
        </button>

        <h1 className="legal-title">Términos y Condiciones de Uso</h1>
        <p className="legal-date">Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="legal-content">
          <section className="legal-section highlight-section">
            <h2>⚠️ AVISO LEGAL IMPORTANTE - DESLINDE DE RESPONSABILIDAD</h2>
            <div className="warning-box">
              <p><strong>GESTIÓN CLUB ES ÚNICAMENTE UN SOFTWARE DE GESTIÓN</strong></p>
              <p>
                Los desarrolladores de Gestión Club <strong>NO SOMOS</strong> operadores, propietarios, gestores, 
                ni tenemos ningún tipo de relación comercial, laboral, societaria o de cualquier otra índole con 
                los clubes, asociaciones o entidades que utilizan nuestro software.
              </p>
              <p>
                <strong>NO PARTICIPAMOS</strong> en las actividades, operaciones, decisiones empresariales, 
                gestión diaria ni en ningún aspecto del funcionamiento de las asociaciones que usan nuestro software.
              </p>
              <p>
                Gestión Club es una <strong>HERRAMIENTA TECNOLÓGICA NEUTRAL</strong> diseñada para facilitar 
                la gestión administrativa y contable de asociaciones. La responsabilidad sobre el uso del 
                software y el cumplimiento de toda la normativa aplicable recae <strong>EXCLUSIVAMENTE</strong> 
                en cada club o asociación usuaria.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar Gestión Club (en adelante, "el Software"), aceptas estar vinculado por estos 
              Términos y Condiciones. Si no estás de acuerdo con alguna parte de estos términos, no debes utilizar 
              el Software.
            </p>
            <p>
              El uso del Software implica la aceptación expresa de:
            </p>
            <ul>
              <li>Estos Términos y Condiciones</li>
              <li>Nuestra Política de Privacidad</li>
              <li>Cualquier política o directriz adicional publicada en el Software</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>2. Descripción del Servicio</h2>
            <p>
              Gestión Club es un software de gestión administrativa basado en la nube (SaaS - Software as a Service) 
              diseñado para ayudar a clubes y asociaciones cannábicas en la gestión de:
            </p>
            <ul>
              <li>Socios y membresías</li>
              <li>Control de stock de productos</li>
              <li>Dispensación y aportaciones</li>
              <li>Contabilidad y facturación</li>
              <li>Control de accesos</li>
              <li>Gestión de proveedores</li>
              <li>Informes y estadísticas</li>
            </ul>
            <p>
              <strong>El Software es una herramienta técnica</strong> y no implica asesoramiento legal, fiscal, 
              contable ni de ningún otro tipo profesional.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Naturaleza del Servicio - Responsabilidades</h2>
            <h3>3.1 Rol de los Desarrolladores</h3>
            <p>
              Los desarrolladores de Gestión Club <strong>ÚNICAMENTE</strong>:
            </p>
            <ul>
              <li>✓ Desarrollamos y mantenemos el software</li>
              <li>✓ Proporcionamos soporte técnico</li>
              <li>✓ Realizamos actualizaciones y mejoras</li>
              <li>✓ Garantizamos la disponibilidad del servicio</li>
            </ul>

            <h3>3.2 Lo que NO Somos ni Hacemos</h3>
            <p>
              Los desarrolladores de Gestión Club <strong>NO</strong>:
            </p>
            <ul>
              <li>❌ NO operamos clubes ni asociaciones cannábicas</li>
              <li>❌ NO gestionamos ni administramos ningún club</li>
              <li>❌ NO tomamos decisiones sobre las operaciones de los clubes</li>
              <li>❌ NO participamos en actividades de los clubes</li>
              <li>❌ NO tenemos relación comercial con proveedores de los clubes</li>
              <li>❌ NO manejamos productos ni sustancias</li>
              <li>❌ NO accedemos a los datos de los socios de los clubes</li>
              <li>❌ NO intervenimos en las relaciones club-socio</li>
              <li>❌ NO asesoramos sobre aspectos legales o regulatorios</li>
              <li>❌ NO nos responsabilizamos del cumplimiento normativo de los clubes</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Responsabilidad del Usuario (Club o Asociación)</h2>
            <p>
              Cada club o asociación que utiliza Gestión Club es <strong>PLENAMENTE RESPONSABLE</strong> de:
            </p>

            <h3>4.1 Cumplimiento Legal</h3>
            <ul>
              <li>Cumplir con toda la normativa local, autonómica, estatal y europea aplicable</li>
              <li>Obtener todas las licencias, permisos y autorizaciones necesarias</li>
              <li>Mantener actualizada toda la documentación legal requerida</li>
              <li>Cumplir con la legislación sobre asociaciones cannábicas</li>
              <li>Respetar las normativas de protección de datos (RGPD)</li>
              <li>Cumplir con obligaciones fiscales y tributarias</li>
            </ul>

            <h3>4.2 Uso del Software</h3>
            <ul>
              <li>Utilizar el Software de manera lícita y conforme a estos términos</li>
              <li>Garantizar la veracidad de los datos introducidos</li>
              <li>Mantener la confidencialidad de las credenciales de acceso</li>
              <li>Proteger el acceso al Software frente a terceros no autorizados</li>
              <li>Realizar copias de seguridad adicionales de sus datos si lo considera necesario</li>
              <li>Informar a sus socios sobre el uso del Software y el tratamiento de datos</li>
            </ul>

            <h3>4.3 Gestión de Datos</h3>
            <ul>
              <li>Actuar como responsable del tratamiento de datos personales</li>
              <li>Garantizar los derechos ARCO de sus socios</li>
              <li>Implementar medidas de seguridad adecuadas</li>
              <li>Notificar brechas de seguridad a las autoridades competentes</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Limitación de Responsabilidad</h2>
            <h3>5.1 Exclusión de Responsabilidad</h3>
            <p>
              <strong>EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY</strong>, los desarrolladores de Gestión Club 
              NO son responsables de:
            </p>
            <ul>
              <li>❌ Actividades ilegales realizadas por clubes usuarios del Software</li>
              <li>❌ Incumplimientos normativos de los clubes usuarios</li>
              <li>❌ Sanciones, multas o procedimientos legales contra clubes usuarios</li>
              <li>❌ Daños derivados del mal uso del Software</li>
              <li>❌ Pérdidas económicas de los clubes</li>
              <li>❌ Conflictos entre clubes y sus socios</li>
              <li>❌ Problemas derivados de la introducción de datos erróneos</li>
              <li>❌ Decisiones empresariales tomadas por los clubes</li>
              <li>❌ Incidencias causadas por proveedores externos (Firebase, hosting, etc.)</li>
            </ul>

            <h3>5.2 Indemnización</h3>
            <p>
              El usuario (club o asociación) acepta indemnizar y mantener indemnes a los desarrolladores de 
              Gestión Club frente a cualquier reclamación, demanda, pérdida, daño, coste, gasto (incluyendo 
              honorarios legales) derivados de:
            </p>
            <ul>
              <li>El uso del Software por parte del usuario</li>
              <li>Incumplimiento de estos Términos y Condiciones</li>
              <li>Violación de derechos de terceros</li>
              <li>Actividades del club usuario</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Propiedad Intelectual</h2>
            <p>
              Todos los derechos de propiedad intelectual sobre el Software, incluidos pero no limitados a 
              código fuente, diseño, marca, logotipos y documentación, son propiedad exclusiva de Gestión Club.
            </p>
            <p>
              Se concede al usuario una licencia limitada, no exclusiva, no transferible y revocable para 
              utilizar el Software conforme a estos términos.
            </p>
            <p>
              <strong>Prohibido:</strong>
            </p>
            <ul>
              <li>Copiar, modificar o crear trabajos derivados del Software</li>
              <li>Realizar ingeniería inversa, descompilar o desensamblar el Software</li>
              <li>Revender, sublicenciar o transferir el Software a terceros</li>
              <li>Eliminar avisos de propiedad intelectual</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Disponibilidad del Servicio</h2>
            <p>
              Nos esforzamos por mantener el Software disponible 24/7, pero no garantizamos que el servicio 
              será ininterrumpido o libre de errores.
            </p>
            <p>
              Podemos realizar mantenimientos programados que pueden afectar temporalmente la disponibilidad. 
              Intentaremos notificar con antelación cuando sea posible.
            </p>
            <p>
              <strong>No nos hacemos responsables</strong> de interrupciones del servicio causadas por:
            </p>
            <ul>
              <li>Mantenimiento necesario</li>
              <li>Fallos de infraestructura de terceros (Firebase, proveedores de internet, etc.)</li>
              <li>Casos de fuerza mayor</li>
              <li>Ataques informáticos o de denegación de servicio</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Modificaciones del Servicio</h2>
            <p>
              Nos reservamos el derecho de:
            </p>
            <ul>
              <li>Modificar, suspender o discontinuar cualquier aspecto del Software</li>
              <li>Añadir o eliminar funcionalidades</li>
              <li>Cambiar la estructura de precios (con notificación previa de 30 días)</li>
              <li>Modificar estos Términos y Condiciones (notificando a los usuarios)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Terminación de la Cuenta</h2>
            <h3>9.1 Por el Usuario</h3>
            <p>
              El usuario puede cancelar su cuenta en cualquier momento contactando con info@gestionclub.com.
              Los datos serán eliminados conforme a nuestra Política de Privacidad.
            </p>

            <h3>9.2 Por Gestión Club</h3>
            <p>
              Nos reservamos el derecho de suspender o terminar cuentas que:
            </p>
            <ul>
              <li>Incumplan estos Términos y Condiciones</li>
              <li>Utilicen el Software para fines ilegales</li>
              <li>No realicen los pagos correspondientes</li>
              <li>Pongan en riesgo la seguridad o estabilidad del Software</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>10. Protección de Datos</h2>
            <p>
              El tratamiento de datos personales se rige por nuestra Política de Privacidad, que forma parte 
              integral de estos términos.
            </p>
            <p>
              <strong>Recordatorio importante:</strong> Cada club es el responsable del tratamiento de los datos 
              de sus socios. Gestión Club actúa como encargado del tratamiento únicamente proporcionando la 
              infraestructura técnica.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Ley Aplicable y Jurisdicción</h2>
            <p>
              Estos Términos y Condiciones se rigen por la legislación española.
            </p>
            <p>
              Para cualquier controversia derivada de estos términos, las partes se someten a los Juzgados y 
              Tribunales de Barcelona, España, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Divisibilidad</h2>
            <p>
              Si cualquier disposición de estos términos se considera inválida o inaplicable, las demás 
              disposiciones permanecerán en pleno vigor y efecto.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Contacto</h2>
            <p>
              Para cualquier consulta sobre estos Términos y Condiciones:
            </p>
            <p>
              <strong>Email:</strong> info@gestionclub.com<br/>
              <strong>Ubicación:</strong> Barcelona, España
            </p>
          </section>

          <section className="legal-section">
            <p className="final-notice">
              <strong>AL UTILIZAR GESTIÓN CLUB, CONFIRMAS QUE HAS LEÍDO, ENTENDIDO Y ACEPTADO ESTOS TÉRMINOS 
              Y CONDICIONES EN SU TOTALIDAD.</strong>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;

